import { BasicCalls } from '..'

class NextCanteen extends BasicCalls {
    constructor() {
        super()
        this.apiRoot = 'frontend-api'
        this.apiVersion = null
        this.apiBase = 'canteen/get-next-canteen'
    }
}

export { NextCanteen }
